import { SharingTipContextMenuItem } from '../../components/SharingTipContextMenuItem';
import ComposeLinkViewState from '../../store/schema/ComposeLinkViewState';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getSharingDataFromLink, getSharingLinkInfo, SharingLinkInfo } from 'owa-link-data';
import { lazyGetSharingIssuesForSharingData, SharingTipRecipientInfo } from 'owa-sharing-data';
import * as React from 'react';

export function getSharingTipContextMenuItems(
    composeLinkViewState: ComposeLinkViewState,
    recipientInfos: SharingTipRecipientInfo[],
    composeId: string
): IContextualMenuItem[] | null {
    // We need the flights for sharing tips and contextual sharing tips to show this menu item
    if (!isFeatureEnabled('doc-attachment-contextualSharingTips')) {
        return null;
    }

    const getSharingIssuesForSharingData = lazyGetSharingIssuesForSharingData.tryImportForRender();

    if (!getSharingIssuesForSharingData) {
        return null;
    }

    const sharingData = getSharingDataFromLink(composeLinkViewState.linkId);
    const sharingIssues = getSharingIssuesForSharingData(sharingData, recipientInfos);

    // Only show the menu item if there is a sharing tip that the user has not chosen to ignore
    if (sharingIssues.length > 0) {
        if (sharingIssues.length > 1) {
            logUsage('AttachmentLinkMultipleSharingTipsShown');
        }
        const contextMenuItems: IContextualMenuItem[] = [];

        sharingIssues.map(sharingIssue => {
            const sharingLinkInfo: SharingLinkInfo = getSharingLinkInfo(
                composeLinkViewState.linkId
            );

            contextMenuItems.push({
                key: 'contextualSharingTip',
                onRender: (
                    item: any,
                    dismissMenu: (ev?: any, dismissAll?: boolean) => void
                ): React.ReactNode => {
                    return (
                        // The SharingTipContextMenuItem must be its own component, as it is dynamic and needs an
                        // observer in order to show status updates
                        <SharingTipContextMenuItem
                            sharingIssue={sharingIssue}
                            sharingLinkInfo={sharingLinkInfo}
                            composeId={composeId}
                            recipientInfos={recipientInfos}
                        />
                    );
                },
            });
        });
        return contextMenuItems;
    }

    return null;
}
